import {
  Map as IMap,
} from 'immutable';
import {
  Component,
  JSXElement,
  Show,
  createSignal,
  useContext,
} from 'solid-js';
import {
  Button,
  DialogParams,
  LocalizationContext,
  MarkdownEditor,
} from '../components';
import { ContentMarkdown, NewContentMarkdownInput } from '../components/api-generated';

export const PromptMarkdownDialog: Component<DialogParams<NewContentMarkdownInput | undefined> & {
  header: JSXElement;
  message?: JSXElement;
  label?: JSXElement;
  value?: ContentMarkdown;
  projectId?: string;
  ok?: JSXElement;
  cancel?: JSXElement;
}> = (props) => {
  const { t, lang: currentLang } = useContext(LocalizationContext)!;

  const sigMarkdown = createSignal(props.value?.markdown ?? '');
  const sigLang = createSignal(props.value?.lang);
  const sigImages = createSignal(IMap((props.value?.images ?? []).map((image) => [image.id, image])));

  const resolve = () => {
    props.resolve({
      markdown: sigMarkdown[0](),
      lang: sigLang[0]() ?? currentLang(),
      images: sigImages[0]().toArray().map((image) => image[0]),
    });
  };

  return (
    <props.dialog class="sheet ui big dialog_prompt_markdown">
      <h1>{props.header}</h1>
      <Show when={props.message}>
        <div class="message">{props.message}</div>
      </Show>
      <label class="input">
        <div class="label">{props.label}</div>
        <MarkdownEditor markdown={sigMarkdown} lang={sigLang} images={sigImages} projectId={props.projectId} level={2} ugc={true} linkInNewTab={true} />
      </label>
      <div class="footer">
        <div class="buttons align_end">
          <Button type="submit" onClick={resolve}>{props.ok ?? t('ok')}</Button>
          <Button onClick={() => props.resolve(undefined)}>{props.cancel ?? t('cancel')}</Button>
        </div>
      </div>
    </props.dialog>
  );
};
